import { Typography } from "@mui/material";

export default function LatestLoginCell({ value, color }) {
  return (
    <Typography
      variant="body2"
      sx={{
        color: color || "#6b7280",
        fontWeight: 500,
        fontSize: "0.875rem",
      }}
    >
      {value}
    </Typography>
  );
}
